<template lang="pug">
  .hero
    .container
      .hero__body
        .hero__image
          img(src="../assets/image/kv2022.svg")
        .hero__title
          h1 SAP CX DAY 2022
          .hero__date 2022年10月4日(火) 13:30-18:00<span>|</span> 会場：WITH HARAJUKU HALL（東京都渋谷区）
          p SAP CX DAY 2022  は、多くのお客様にご参加いただき<span class="d-inline-block">好評のうちに終了いたしました。誠にありがとうございました。</span>

</template>

<script>
import Register from "@/components/Register.vue";

export default {
  components: {
    Register
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/_variables.scss";

.container {
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 16px;
  color: #fff;
}

.inline-block {
  display: inline-block;
}

.hero {
  background-color: #000;

  &__body {

  }

  &__image {

    img {
      margin: auto;
      display: block;
      max-width: 100%;
    }
  }

  &__title {
    padding-bottom: 60px;
    text-align: center;
    max-width: 100%;

    h1 {
      font-size: 36px;
      color: $secondary-color;
      font-family: Arial, sans-serif;
      margin: 40px 0 0;
    }

    .btn {
      max-width: 280px;
      text-align: center;
      margin-top: 40px;
    }

    p {
      font-weight: 300;
      padding: 10px;
      background-color: $secondary-color;
      color: #000;
      font-weight: 600;
      line-height: 1.4;
      margin: 20px auto 0;
      text-align: left;
      border-radius: 1px;

      @media screen and (min-width: 768px) {
        width: 60%;
        text-align: center;
      }

      span {
        @media screen and (min-width: 768px) {
          display: inline-block;
        }
      }
    }
  }

  &__date {
    margin-top: 8px;

    span {
      opacity: 0.4;
      padding: 0 .3em;
    }
  }
}
</style>